import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EventRequestListSummary } from 'legacy/common/types/models';
import EventUsersBadge, {
  BadgeType
} from 'legacy/common/components/wysiwyg-form/EventUsersBadge';

import RequestListModal from './components/RequestListModal';

const MAX_REQUEST_LIST_BADGES = 5;
interface RequestListProps {
  eventId: string;
  requestListSummary: EventRequestListSummary;
}

const EventRequestList: React.FC<RequestListProps> = ({
  eventId,
  requestListSummary
}) => {
  const { t } = useTranslation(['events']);
  const [showRequestListModal, setShowRequestListModal] = useState(false);

  const toggleRequestListModal = () => {
    setShowRequestListModal((showRequestListModal) => !showRequestListModal);
  };

  const users =
    useMemo(
      () =>
        requestListSummary.tierApprovals?.map(
          (tierApproval) => tierApproval.user
        ),
      [requestListSummary.tierApprovals]
    ) || [];

  return (
    <>
      <EventUsersBadge
        data={users}
        onClick={toggleRequestListModal}
        badgeType={BadgeType.Large}
        title={t('events:dashboard.ticketing.ticketRequests')}
        secondaryDefaultText={
          <div className="flex gap-1">
            <span className="font-bold">
              {requestListSummary.newCount || 0}&nbsp;
              {t('events:dashboard.ticketing.unread')}
            </span>
            <span>•</span>
            <span>
              {requestListSummary.totalApprovalsCount || 0}&nbsp;
              {t('events:dashboard.ticketing.total')}
            </span>
          </div>
        }
        additionalGuests={
          requestListSummary?.tierApprovals?.length > 0
            ? Math.max(
                requestListSummary?.tierApprovals?.length -
                  MAX_REQUEST_LIST_BADGES,
                0
              )
            : 0
        }
      />

      {showRequestListModal && (
        <RequestListModal
          total={requestListSummary?.pendingCount}
          eventId={eventId}
          onClose={toggleRequestListModal}
        />
      )}
    </>
  );
};

export default EventRequestList;
